import { http } from '@/axios';
import { prepareRegisterFormData } from '../../helpers/registerCandidate';

function getInitState() {
  return {
    formLists: {},
    error: null,
  };
}

export default {
  namespaced: true,
  state: getInitState(),
  actions: {
    async updateFormLists({ commit }) {
      try {
        const { data } = await http.get('/api/cabinet/agent/register-candidate/datalist');
        commit('setProperty', ['formLists', data.data]);
        commit('setProperty', ['error', null]);
      } catch (e) {
        commit('setProperty', ['error', e]);
      }
    },
    register(_, payload) {
      return http.post('/api/cabinet/agent/register-candidate', prepareRegisterFormData(payload));
    },
  },
  mutations: {
    setProperty(state, [key, value]) {
      state[key] = value
    },
  },
  getters: {
    formLists(state) {
      return state.formLists;
    },
    error(state) {
      return state.error;
    },
  },
};
